module.exports = __webpack_public_path__ + "img/slider_d01.5350fbb.87d8606f.png";